<template>
	<div class="w-100 position-relative">
		<!-- Search Backdrop (Blur effect) -->
		<div
			v-if="searchActive"
			class="search-backdrop"
			@click="closeSearchDropdown"
		></div>
		<div class="lp-header-outer-container">
			<!-- Main Header Bar -->
			<header
				class="lp-hedaer d-flex align-items-center justify-content-between"
			>
				<!-- Logo -->
				<div>
					<img
						class="logo pointer"
						@click="goToHire3xHome()"
						src="https://d33yrtc8qntbdn.cloudfront.net/Hire3xAssests/Website/Header/hire3x-logo.svg"
						alt="Hire3x Logo"
					/>
				</div>

				<!-- Extra Div when search active (matching GuestHeader) -->
				<div :class="{ 'extra-div': searchActive }"></div>

				<!-- Center Header Area: Tabs & Search Bar -->
				<div class="header-center-area">
					<!-- Tabs: Jobs | Assessments | Courses (visible when searchActive is true) -->
					<div
						class="search-tabs-container"
						:class="{ 'is-active': searchActive }"
						v-show="searchActive"
					>
						<div
							class="search-tab"
							@click="selectTab('job')"
							:class="{ active: selectedTab === 'job' }"
						>
							Jobs
						</div>
						<span class="divider">|</span>
						<div
							class="search-tab"
							@click="selectTab('assessment')"
							:class="{ active: selectedTab === 'assessment' }"
						>
							Assessments
						</div>
						<span class="divider">|</span>
						<div
							class="search-tab"
							@click="selectTab('course')"
							:class="{ active: selectedTab === 'course' }"
						>
							Courses
						</div>
					</div>

					<!-- Search Input (when search is inactive) -->
					<section
						v-if="!searchActive"
						class="ncd-top-search-input position-relative pointer"
						@click="openSearch"
					>
						<img
							src="../../assets/NewDashboard/Mobiledesign/newsearch.svg"
							class="ncd-search-img-pos"
							alt=""
						/>
						<b-form-input
							placeholder="Search for jobs, skills, companies..."
							readonly
							@click="openSearch"
							@focus="openSearch"
						></b-form-input>
					</section>

					<!-- Search Bar Wrapper (when search is active) -->
					<div
						v-else
						class="search-bar-wrapper is-active"
						ref="searchContainer"
					>
						<div class="w-75 mt-3">
							<div class="ncd-top-search-input position-relative w-100">
								<img
									src="../../assets/NewDashboard/Mobiledesign/newsearch.svg"
									class="ncd-search-img-pos"
									alt=""
								/>
								<b-form-input
									ref="headerSearchInput"
									type="text"
									name="global-search"
									placeholder="Search for jobs, skills, companies..."
									v-model="searchQuery"
									@input="onSearchInput"
									@keydown.enter.native.prevent="
										performSearch(getLiveSearchQuery())
									"
									autocomplete="off"
									autocapitalize="off"
									autocorrect="off"
									spellcheck="false"
								></b-form-input>
							</div>
						</div>

						<!-- Search Dropdown Content Component -->
						<SearchDropdown
							:isVisible="searchActive"
							:selectedTab="selectedTab"
							:headerSearchQuery="searchQuery"
							:headerSearchSuggestion="searchSuggestion"
							:isSearching="isSearchLoading"
							@close-modal="closeSearchDropdown"
							@click-history="handleHistorySelection"
							@openResumeClinic="openResumeClinicModal"
						/>
					</div>
				</div>

				<div
					class="position-relative mr-3"
					v-if="count > 1 && $route.name != 'ViewPublicProfile'"
				>
					<div
						class="switch-project-pill pointer"
						@click="showswitch = !showswitch"
						ref="switch"
						id="switch"
					>
						<img
							src="@/assets/icons/switch-projects.svg"
							alt="Switch Project"
							class="switch-project-icon"
						/>
						<img
							src="@/assets/icons/switch-arrow.svg"
							alt="Switch Arrow"
							class="switch-arrow-icon"
							:class="{ rotated: showswitch }"
						/>
					</div>
					<div
						class="allproj-dropdown justify-content-center"
						v-if="showswitch"
						ref="switch-body"
						v-closable="{
							exclude: ['switch-body', 'switch'],
							handler: 'closeSwitch',
						}"
					>
						<div class="allproj-card allproj-card-selected">
							<img
								src="../../assets/icons/switch-project-icons/cand.svg"
								alt=""
							/>

							<div class="allproj-card-head">Candidates</div>

							<div class="allproj-card-subhead">
								Login to resume builder, much more
							</div>
						</div>

						<div
							class="allproj-card"
							v-if="accessAssessment"
							@click="goToProject('assessment')"
						>
							<img
								src="../../assets/icons/switch-project-icons/assess.svg"
								alt=""
							/>

							<div class="allproj-card-head">Assessment</div>

							<div class="allproj-card-subhead">
								Create, manage assessment progress
							</div>
						</div>
						<div
							class="allproj-card"
							v-if="accessRecruitment"
							@click="goToProject('recruitment')"
						>
							<img
								src="../../assets/icons/switch-project-icons/rec.svg"
								alt=""
							/>

							<div class="allproj-card-head">Recruitment</div>

							<div class="allproj-card-subhead">
								Build & hire from our network, AI features
							</div>
						</div>
						<div
							class="allproj-card"
							v-if="accessTraining"
							@click="goToProject('training')"
						>
							<img
								src="../../assets/icons/switch-project-icons/training.svg"
								alt=""
							/>

							<div class="allproj-card-head">Training</div>

							<div class="allproj-card-subhead">
								Create, manage & edit course videos
							</div>
						</div>
					</div>
				</div>
				<!-- Right Notification Icon -->
				<div ref="notificationddset">
					<div class="position-relative">
						<img
							class="pointer"
							:src="
								notificationCount > 0
									? require('../../assets/NewDashboard/lapnotification.svg')
									: require('../../assets/NewDashboard/lapnotificationvthoutred.svg')
							"
							alt="Notifications"
							@click="isnotiDropdownOpen = !isnotiDropdownOpen"
						/>
						<Notifications
							v-if="isnotiDropdownOpen"
							@closeNotificationDropdown="isnotiDropdownOpen = false"
							@changeCountvalue="changeReadUnreadcount"
							@allRead="fetchUnreadCount"
						/>
					</div>
				</div>
			</header>
		</div>
		<!-- Resume Clinic Modal -->
		<ResumeClinicModal
			v-if="showResumeClinicModal"
			:showModal="showResumeClinicModal"
			@modalClose="closeResumeClinicModal"
			:showfromhelpsection="false"
			:clinicDatafromhs="resumeClinicData"
			@openLoginModal="openLoginModal"
			@openLoginModalWithJobID="openLoginModalWithJobID"
		/>
	</div>
</template>

<script>
import SearchDropdown from "@/components/fixedcomponents/SearchDropdown.vue";
import ResumeClinicModal from "@/components/BuilderPage/ResumeclinicModal.vue";
import Notifications from "@/components/Notifications.vue";
import globalSearchMixin from "@/components/mixin/globalSearchMixin";
import { resumeAnalysis } from "@/utils/apiFunctions";
import EventBus from "@/utils/EventBus";
import { mapGetters } from "vuex";
import { config } from "@/config";
import "@/assets/globalcss/headerpage.css";

export default {
	name: "LandingpageHeader",
	mixins: [globalSearchMixin],
	components: {
		SearchDropdown,
		ResumeClinicModal,
		Notifications,
	},
	data() {
		return {
			selectedTab: "job",
			searchActive: false,
			showResumeClinicModal: false,
			resumeClinicData: {},
			isnotiDropdownOpen: false,
			showswitch: false,
			accessRecruitment: false,
			accessTraining: false,
			accessCandidate: true,
			accessAssessment: false,
			count: 0,
			config,
		};
	},
	computed: {
		unreadCount() {
			if (this.showUnreadCount) return this.showUnreadCount;
			else return 0;
		},
		// Total notification count from the store. The bell icon shows the
		// "with red" version whenever there is any notification, otherwise the
		// plain/no-red bell.
		notificationCount() {
			return this.getNotificationCount || 0;
		},
		...mapGetters("userVUEX", {
			showUnreadCount: "getUnreadCount",
			getNotificationCount: "getNotificationCount",
		}),
	},
	watch: {
		searchActive(val) {
			if (val) {
				this.selectedTab = "job";
				document.body.style.overflow = "hidden";
			} else {
				document.body.style.overflow = "";
			}
		},
	},
	mounted() {
		document.addEventListener("mousedown", this.handleDocumentClick, true);
		document.addEventListener("click", this.handleClickOutside);
		EventBus.$on("login-success", this.createdActions);
		EventBus.$on("onboarding-fetch-post-login", this.createdActions);
		this.createdActions();
	},
	beforeDestroy() {
		document.removeEventListener("mousedown", this.handleDocumentClick, true);
		document.removeEventListener("click", this.handleClickOutside);
		EventBus.$off("login-success", this.createdActions);
		EventBus.$off("onboarding-fetch-post-login", this.createdActions);
		document.body.style.overflow = "";
	},
	methods: {
		createdActions() {
			this.fetchUnreadCount();
			this.getCookieData();
		},
		closeSwitch() {
			this.showswitch = false;
		},
		goToProject(type) {
			let redirecturl;
			if (type === "recruitment") redirecturl = this.config.recruitmentBase;
			else if (type === "assessment") redirecturl = this.config.assessmentBase;
			else if (type === "training")
				redirecturl = `${this.config.trainingAdminBase}/?from=candidate`;
			else if (type === "candidate") redirecturl = this.config.candidateBase;

			if (redirecturl) {
				window.open(redirecturl);
			}
			this.showswitch = false;
		},
		getCookieData() {
			let data = document.cookie.split(";");
			for (let i in data) {
				let token = data[i].split("=")[0];
				if (token.trim() === "assessment") {
					this.accessAssessment = data[i].split("=")[1] !== "no-access";
					this.accessAssessment ? this.count++ : "";
				}
				if (token.trim() === "training") {
					this.accessTraining = data[i].split("=")[1] !== "no-access";
					this.accessTraining ? this.count++ : "";
				}
				if (token.trim() === "recruitment") {
					this.accessRecruitment = data[i].split("=")[1] !== "no-access";
					this.accessRecruitment ? this.count++ : "";
				}
			}
		},
		async fetchUnreadCount() {
			this.$store.dispatch("userVUEX/fetchUnreadCount");
		},
		changeReadUnreadcount(change) {
			this.unreadCount += change;
		},
		handleClickOutside(event) {
			const notificationEl = this.$refs.notificationddset;
			if (notificationEl && !notificationEl.contains(event.target)) {
				this.isnotiDropdownOpen = false;
			}
		},
		goToHire3xHome() {
			window.location.href = `${this.config.websiteBase}`;
		},
		handleDocumentClick(event) {
			if (!this.searchActive) return;
			const searchContainer = this.$refs.searchContainer;
			if (
				!event.target.closest(
					".search-bar-wrapper, .search-tabs-container, .ncd-top-search-input"
				)
			) {
				this.closeSearchDropdown();
			}
		},
		openSearch() {
			this.selectedTab = "job";
			this.searchQuery = "";
			this.searchSuggestion = [];
			this.searchActive = true;
			this.getRecentSearches("job");
			this.getTrendingTagsData("job");
			this.$nextTick(() => {
				if (this.$refs.headerSearchInput) {
					const el =
						this.$refs.headerSearchInput.$el || this.$refs.headerSearchInput;
					if (el && el.focus) el.focus();
				}
			});
		},
		closeSearchDropdown() {
			this.searchActive = false;
			this.selectedTab = "job";
			this.searchQuery = "";
			this.searchSuggestion = [];
		},
		selectTab(data) {
			this.selectedTab = data;
			this.searchQuery = "";
			this.searchSuggestion = [];
			this.getRecentSearches(data);
			this.getTrendingTagsData(data);
		},
		getLiveSearchQuery() {
			const inputRef = this.$refs.headerSearchInput;
			if (!inputRef) return (this.searchQuery || "").toString();

			const rootEl = inputRef.$el || inputRef;
			if (rootEl && typeof rootEl.value === "string") {
				return rootEl.value;
			}

			const nestedInput =
				rootEl && rootEl.querySelector ? rootEl.querySelector("input") : null;
			return nestedInput && typeof nestedInput.value === "string"
				? nestedInput.value
				: (this.searchQuery || "").toString();
		},
		handleHistorySelection(query) {
			this.searchQuery = query;
			this.performSearch(query);
		},
		performSearch(forcedQuery = null) {
			const query = (
				forcedQuery ??
				this.getLiveSearchQuery() ??
				this.searchQuery
			)
				.toString()
				.trim();
			const type = this.selectedTab;
			if (!query) return;

			this.searchQuery = query;
			this.closeSearchDropdown();
			this.handleEnterSearch(query, type);
		},
		async openResumeClinicModal() {
			await this.fetchResumeClinicData();
			this.showResumeClinicModal = true;
		},
		async fetchResumeClinicData() {
			try {
				const res = await resumeAnalysis();
				if (res.status === 200) {
					this.resumeClinicData = res.data?.data?.analysis || {};
				}
			} catch (error) {
				console.log(error);
			}
		},
		closeResumeClinicModal() {
			this.showResumeClinicModal = false;
		},
		openLoginModal(uuid) {
			this.$store.commit("userVUEX/SET_RESUME_UUID", uuid);
			this.$store.commit("userVUEX/setresumeJobid", null);
			EventBus.$emit("open-login-modal");
		},
		openLoginModalWithJobID(jobId, uuid) {
			this.$store.commit("userVUEX/SET_RESUME_UUID", uuid);
			this.$store.commit("userVUEX/setresumeJobid", jobId);
			EventBus.$emit("open-login-modal");
		},
	},
};
</script>

<style scoped>
.lp-header-outer-container {
	background: #ffffff;
	border: 1px solid rgba(140, 140, 140, 0.33);
	width: 100%;
	margin: 0 auto;
	height: 64px;
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	z-index: 1000;
}
.lp-hedaer {
	padding: 10px 24px;
	max-width: 1950px;
	/* width: 100%;
	height: 100%; */
	margin: 0 auto;
}
.header-center-area {
	flex: 1;
	height: 100%;
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
}

/* Original LandingPage Header Search Input Styling */
.ncd-top-search-input .form-control {
	padding: 12px 16px 12px 42px;
	width: 488px;
	height: 42px;
	background: #ffffff;
	border: 1px solid #e9e9e9;
	box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.0313726);
	border-radius: 12px;
	font-family: "Inter", sans-serif;
	font-size: 14px;
}
.search-bar-wrapper .ncd-top-search-input .form-control {
	width: 100%;
}
.ncd-top-search-input .form-control::placeholder {
	font-family: "Inter", sans-serif;
	font-style: normal;
	font-weight: 400;
	font-size: 14px;
	color: #94a3b8;
}
.ncd-search-img-pos {
	position: absolute;
	left: 16px;
	top: 12px;
	z-index: 2;
}

/* Tabs styling matching GuestHeader */
.search-tabs-container {
	display: flex;
	align-items: center;
	justify-content: center;
	border: 1px solid #c4dcf6;
	border-radius: 74px;
	padding: 4px 6px;
	gap: 15px;
	background-color: white;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	height: 44px;
	z-index: 1001;
	opacity: 1;
}
.search-tab {
	background: transparent;
	border: none;
	font-family: "Inter", sans-serif;
	font-size: 15px;
	color: #4a7eff;
	cursor: pointer;
	font-weight: 500;
	padding: 4px 16px;
	border-radius: 30px;
	transition: all 0.2s;
}
.search-tab.active {
	background: #4a7eff;
	color: white;
}
.divider {
	color: #c4dcf6;
}

/* Search Bar Wrapper positioning matching GuestHeader */
.search-bar-wrapper {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: 100%;
	max-width: 488px;
	transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
	z-index: 1000;
	display: flex;
	flex-direction: column;
	align-items: center;
}
.search-bar-wrapper.is-active {
	top: 45px;
	max-width: 800px;
	width: 100%;
}

/* Backdrop */
.search-backdrop {
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
	background: rgba(0, 0, 0, 0.15);
	backdrop-filter: blur(6px);
	-webkit-backdrop-filter: blur(6px);
	z-index: 999;
}

.extra-div {
	background: #ffffff;
	width: 100vw;
	height: 85px;
	position: absolute;
	left: 0;
	top: 60px;
	z-index: 998;
}

/* Switch Project Pill */
.switch-project-pill {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	background-color: #e8effe;
	border-radius: 30px;
	padding: 8px 16px;
	gap: 10px;
	transition: background-color 0.2s ease, box-shadow 0.2s ease;
	user-select: none;
}

.switch-project-pill:hover {
	background-color: #dce8ff;
}

.switch-project-icon {
	width: 22px;
	height: 22px;
	display: block;
}

.switch-arrow-icon {
	width: 10px;
	height: 7px;
	display: block;
	transition: transform 0.3s ease;
}

.switch-arrow-icon.rotated {
	transform: rotate(180deg);
}

.allproj-dropdown {
	position: absolute;
	right: 0;
	top: 42px;
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	align-items: flex-start;
	align-content: flex-start;
	padding: 16px;
	gap: 16px;
	background: #f6f9fb;
	border-width: 0px 1px 1px 1px;
	border-style: solid;
	border-color: #f6f9fb;
	box-shadow: 0px 83px 33px rgba(0, 0, 0, 0.01),
		0px 47px 28px rgba(0, 0, 0, 0.05), 0px 21px 21px rgba(0, 0, 0, 0.09),
		0px 5px 11px rgba(0, 0, 0, 0.1);
	border-radius: 16px 0px 16px 16px;
	width: 355px;
}

.allproj-card {
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: flex-start;
	padding: 12px;
	gap: 8px;
	height: 136px;
	width: 148px;
	background: #ffffff;
	border: 1px solid rgba(224, 224, 224, 0.5);
	border-radius: 8px;
	cursor: pointer;
}

.allproj-card:hover {
	border: 1px solid #20639b;
}
.allproj-card-selected {
	background: #deecf6 !important;
	border: 1px solid #20639b !important;
}
.allproj-card-selected img {
	background: #fff !important;
	border-radius: 50% !important;
}
.allproj-card-head {
	font-family: "Inter", sans-serif;
	font-style: normal;
	font-weight: 600;
	font-size: 16px;
	line-height: 24px;
	letter-spacing: -0.03em;
	color: #20639b;
	backdrop-filter: blur(2px);
}

.allproj-card:hover .allproj-card-head {
	color: #20639b;
}

.allproj-card-subhead {
	font-family: "Inter", sans-serif;
	font-style: normal;
	font-weight: 400;
	font-size: 12px;
	line-height: 16px;
	color: #333333;
}
</style>
